<template>
  <div class="general-wrapper">
    <Header>
      <template #actions>
        <BaseButton
          class="mr-8"
          variant="primary"
          :color="cart && cart.length ? 'red-4' : 'v1-grey-10'"
          icon="cart"
          size="md"
          @click="$router.push('/stickers_bag')"
        >
          {{ $t("stickers_checkout.title") }}
        </BaseButton>
        <BaseButton
          variant="secondary"
          color="v1-grey-10"
          size="md"
          @click="$router.push('/shipments_archive')"
        >
          {{ $t("tables.orders_history") }}
        </BaseButton>
      </template>
    </Header>

    <PageContainer>
      <div class="stickers-gallery-flexer">
        <StickerByPreviewCard
          @purchase="onPurchase"
          :sticker="selected_template"
        />
        <div class="stickers-row">
          <img
            v-for="template in available_templates"
            :key="template"
            :class="{
              selected: template == selected_template,
            }"
            @click="selected_template = template"
            :src="`/icons/sticker-${template}.png`"
          />
          <div
            class="add-custom-sticker-btn"
            @click="selected_template = 'custom'"
          ></div>
        </div>
      </div>
    </PageContainer>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";
import StickerByPreviewCard from "@/components/StickerByPreviewCard.vue";

export default {
  components: {
    DashboardButton,
    StickerByPreviewCard,
  },
  data() {
    return {
      selected_template: "basic",

      available_templates: ["basic", "classic", "hype"],
      cart: [],
    };
  },
  methods: {
    onPurchase(item) {
      let cart_part = [];

      if (item.system == "inside") {
        let sections =
          item.section >= 0
            ? [this.cafe.sections[item.section]]
            : this.cafe.sections;

        for (let i = 0; i < sections.length; i++) {
          const section = sections[i];

          for (let t = 0; t < section.tables_list.length; t++) {
            cart_part.push({
              template: item.template,
              system: "inside",
              table: t + 1,
              table_name: section.tables_list[t].name || `${t + 1}`,
              section: item.section >= 0 ? item.section : i,
              count: 3,
              language: this.$i18n.locale,
              price: 10,
              custom_url: item.custom_url || null,
            });
          }
        }
      } else {
        cart_part.push({
          template: item.template,
          system: "direct",
          table: 0,
          table_name: null,
          section: -1,
          count: item.count,
          language: this.$i18n.locale,
          price: 10,
          custom_url: item.custom_url || null,
        });
      }

      this.cart = this.cart.concat(cart_part);

      window.localStorage.setItem("stickers_cart", JSON.stringify(this.cart));
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    const cart_cache = window.localStorage.getItem("stickers_cart");

    if (cart_cache) this.cart = JSON.parse(cart_cache);
  },
};
</script>
<style scoped>
.stickers-gallery-flexer {
  display: flex;
  flex-flow: column;

  /* HARDCODE: 64px = header height */
  height: calc(100vh - 64px - 64px);

  justify-content: space-between;
}

.stickers-row {
  display: flex;
  column-gap: 16px;
  width: 100%;
  align-items: center;
}
.stickers-row img {
  width: 80px;
  height: 80px;
  max-width: 80px;
  max-height: 80px;
  cursor: pointer;
  opacity: 0.4;
}

.stickers-row img.selected {
  opacity: 1;
}

.add-custom-sticker-btn {
  background-image: url(/icons/add-stickers.svg);
  max-width: 80px;
  max-height: 80px;
  width: 80px;
  height: 80px;
  background-size: contain;
  cursor: pointer;
}
.add-custom-sticker-btn:hover {
  background-image: url(/icons/add-stickers-hover.svg);
  background-size: contain;
}
</style>
